import { AvailableOrganisationsService, UsersService } from "@/common/api.service";
import { RESET_GLOBAL_STATE, FETCH_AVAILABLE_ORGANISATION, FETCH_LOGIN_USER_DETAILS } from "./actions.type";
import { GLOBAL_STATE_RESET, SET_KIOSK_MODE_STATUS, SET_USERNAME, SET_AVAILABLE_ORGANISATION, SET_LOGIN_USER_DETAILS } from "./mutations.type";


const initialState = () => {
    return {
        enableKioskMode: false,
        username: null,
        availableOrganisation: [],
        loginUserDetails: null
    }
};

export const state = initialState();

const actions = {
    [RESET_GLOBAL_STATE]({ commit }) {
        commit(GLOBAL_STATE_RESET)
    },
    async [FETCH_AVAILABLE_ORGANISATION]({ commit }) {
        try {
            const response = await AvailableOrganisationsService.get();
            commit(SET_AVAILABLE_ORGANISATION, response.data);
        }
        catch (e) {
            return e;
        }
    },
    async [FETCH_LOGIN_USER_DETAILS]({ commit }) {
        try {
            const response = await UsersService.get("user/loggedin");
            commit(SET_LOGIN_USER_DETAILS, response.data);
        }
        catch (e) {
            return e;
        }
    }
}

const mutations = {
    [SET_KIOSK_MODE_STATUS](state, status) {
        state.enableKioskMode = status
    },
    [SET_USERNAME](state, data) {
        state.username = data
    },
    [GLOBAL_STATE_RESET](state) {
        Object.assign(state, initialState())
    },
    [SET_AVAILABLE_ORGANISATION](state, data) {
        state.availableOrganisation = data;
    },
    [SET_LOGIN_USER_DETAILS](state, data) {
        state.loginUserDetails = data;
    }
}

const getters = {
    enableKioskMode(state) {
        return state.enableKioskMode;
    },
    activeusername(state) {
        return state.username
    },
    getAvailableOrganisation(state) {
        return state.availableOrganisation.sort((a, b) => a.name.localeCompare(b.name))
    },
    getLoginUserDetails(state) {
        return state.loginUserDetails
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};
